<div class="container">
    <div class="btn-close" (click)="onClose()">
        <i class="fa fa-close"></i>
    </div>
    <iframe #iframe class="frame" [src]="data  | safe:'resourceUrl'" allowfullscreen></iframe>
</div>

